import { RcFile } from "antd/lib/upload";
import { Category } from "../models";
import { AccessUser } from "./Campaign";
import { FileErrorDescription } from "../models";
import { UploadTask } from "firebase/storage";
import { EligibilityCriterion } from "@/services/bedrock";

export type MediaType = "VIDEO" | "IMAGE" | "MIX" | "REELS";
export type MediaCategory = "VIDEO" | "IMAGE";

export type DeliveryMode = "RANDOM_DELIVERY" | "SPECIFIC_DATE" | "WELCOME_PROMPT" | "LIBRARY";
// NOTE: "RANDOM_DELIVERY" | "SPECIFIC_DATE" were deprecated
export type PromptStatus = "ACTIVE" | "DISABLED" | "DRAFT";

export enum PromptType {
  FEED = "FEED",
  REELS = "REELS",
}

export interface PlayerPrompt {
  deliveryDateTime?: string;
  deliveryErrorMessage?: string;
  id: number;
  isAutoPost: boolean;
  isSaved: boolean;
  lastFailedDeliveryTimestamp: string;
  origin: string;
  playerId: number;
  prompt: Prompt;
}

interface PromptAccessRequest {
  eligibilityCriteria?: EligibilityCriterion[];
}

export interface PromptAccess extends PromptAccessRequest {
  eligiblePlayerIds?: number[];
  accessUsers?: AccessUser[];
}

export interface Prompt {
  promptId?: string | number;
  coachId?: string | number;
  title: string;
  message: string;
  hashtags?: string;
  richMessage?: string;
  status: PromptStatus;
  deliveryMode: DeliveryMode;
  creationDate?: string;
  deliveryDatetimeUtc?: string | null;
  promptAccess?: PromptAccess;
  mediaMessage?: MediaGroup;
  post?: MediaGroup;
  categories?: Category[];
  allowHashtags?: boolean;
  allowShortLink?: boolean;
  smartLinkId?: number;
  allowComplianceDisclaimer?: boolean;
  type?: PromptType;
}

export interface SelectedPrompts {
  [key: string]: SelectedPromptInfo;
}

interface SelectedPromptInfo {
  categoryIds: (string | number)[];
  title: string;
  post?: MediaGroup;
  prompt?: Prompt;
  campaignPromptId?: string;
}

export interface PromptRequest extends Prompt {
  categoryIds?: (string | number)[];
  promptAccess?: PromptAccessRequest;
}

export interface PromptPreview extends PromptRequest {
  thumbnail?: string;
  uploadTask?: UploadTask;
  selected?: boolean;
  withError?: boolean;
  loading: boolean;
  loadStatus?: "LOADING" | "SUBMITTED" | "FAILED";
  uid: string;
}

export interface PromptBulkRequest {
  coachId: string | number;
  deliveryMode: DeliveryMode;
  promptList?: PromptRequest[];
}

export interface PromptBulkResponse {
  error: SCError[];
  successCreated: PromptSuccessResponse[];
}

interface SCError {
  error: string;
  title: string;
}

interface PromptSuccessResponse {
  promptId: number;
  title: string;
}

export interface PromptPreviewObject extends Prompt {
  deliveryTimeUtc?: string | null;
  deliveryDateUtc?: string | null;
  media?: Media[];
}

export interface MediaGroup {
  mediaGroupId?: number;
  type: MediaType;
  media: Media[];
}

export interface Media {
  id: number;
  sortOrder: number;
  category: MediaCategory;
  uri: string;
  thumbnailUri?: string;
  type: string;
  extension: string;
  downloadLink?: string;
  validAspectRatio?: boolean; // To indicate if the images has correct IG aspect ratio
  validDimension?: boolean; // To indicate if the images has correct (REELS)
  imageFile?: File | Blob;
  fileName?: string;
  errors?: FileErrorDescription;
  transcripts?: MediaTranscript[];
}

interface MediaTranscript {
  id?: number;
  content?: string;
  isOriginal?: boolean;
  languageCode?: string;
  createdDate?: string;
}

export interface UploadProgressMap {
  [mediaId: number]: { progress: number; task: UploadTask | undefined };
}

export interface SocialFiles extends RcFile {
  uploadTask?: UploadTask;
  thumbnail?: string;
  progress?: number;
}
